<form style="width: 400px; min-width: 50%">
  <h1 mat-dialog-title>{{'Accounts.addAccount.header' | translate}}</h1>
  <div mat-dialog-content>
    <mat-form-field class="col-12">
      <mat-label>{{'Accounts.lblCode' | translate}}</mat-label>
      <input type="text" matInput placeholder="{{'Accounts.lblCode' | translate}}" [(ngModel)]="account.code" [ngModelOptions]="{standalone: true}" maxlength="10"/>
    </mat-form-field>
    <mat-form-field class="col-12">
      <mat-label>{{'Accounts.lblOrganisation' | translate}}</mat-label>
      <input type="text" matInput placeholder="{{'Accounts.lblOrganisation' | translate}}" [(ngModel)]="account.organisation" [ngModelOptions]="{standalone: true}" maxlength="100"/>
    </mat-form-field>
    <mat-checkbox color="primary" [(ngModel)]="account.enabled" [ngModelOptions]="{standalone: true}">{{'Accounts.ckbxEnabled' | translate}}</mat-checkbox>
  </div>
  <div mat-dialog-actions>
    <button mat-raised-button color="primary" (click)="OnSaveAccount()">{{'btnSave' | translate}}</button>&nbsp;
    <button mat-raised-button color="secondary" (click)="OnCancel()">{{'btnCancel' | translate}}</button>
  </div>
</form>
